import createReactClass from "create-react-class";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import _ from "underscore";
import { ServerActions } from "../actions/serverActions";
import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";
import { runCompareStore } from "../stores/runCompareStore";
const { ActionTypes } = Constants;

function getStateFromStores() {
  return {
    showResult: runCompareStore.showResult(),
    data: runCompareStore.getCompareList(),
    guidsEntry: runCompareStore.getCompareGuids(),
    disableSaveGuid: runCompareStore.getIsRunCompareTriggered(),
    showUpdate: runCompareStore.showUpdate(),
    message: runCompareStore.getComparedMessage(),
  };
}

export const RunCompare = createReactClass({
  componentDidMount: function () {
    runCompareStore.subscribe(this._onChange);
  },

  componentWillUnmount: function () {
    runCompareStore.unsubscribe(this._onChange);
  },
  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  compareItems: function (restrictionList, buttonType) {
    var selectedSub = $("#subdivisionSelect").val();

    var openRestrictionServerRequest =
      ServerActions.openRequestOrRestrictionForRecalculate(
        restrictionList,
        selectedSub
      );
    openRestrictionServerRequest.done(function (data) {
      if (data.success) {
        var selectedSchematic = $("#gisSelect").val();

        //set schematic track names here
        dispatcher.dispatch({
          type: ActionTypes.RUNCOMPARE_CALCULATED_GUIDS,
          results: data.data,
          selectedSub: selectedSub,
          selectedSchematic: selectedSchematic,
        });

        dispatcher.dispatch({
          type:
            buttonType === "compare"
              ? ActionTypes.GET_RUNCOMPARE
              : ActionTypes.GET_UPDATE,
        });
      }
    });
  },
  sortResult: function () {
    dispatcher.dispatch({
      type: ActionTypes.RESET_RUN_COMPARE_DETAILS,
    });
  },

  runCompareButtonGisEnv: function () {
    dispatcher.dispatch({
      type: ActionTypes.RESET_RUN_COMPARE_DETAILS,
    });
    dispatcher.dispatch({
      type: ActionTypes.RESET_COMPARE_DETAILS,
    });

    var pluck = _.pluck(this.state.data, "requestId");
    console.log("runCompareButtonGisEnv being called");

    var val = $("#subdivisionSelect").val();
    if (val == null) {
      alert("Please select a subdivision");
      return;
    }
    this.compareItems(pluck, "compare");

    dispatcher.dispatch({
      type: ActionTypes.GET_RUNCOMPARE_CLICKED,
    });
  },

  closeResult: function () {
    dispatcher.dispatch({
      type: ActionTypes.CLOSE_COMPARE_RESULTS,
    });
  },
  render: function () {
    var disabledRunCompare = false;
    var rowClicked = runCompareStore.getRowClicked();
    if (rowClicked) {
      disabledRunCompare = rowClicked;
    } else {
      disabledRunCompare = !(this.state.data && this.state.data.length != 0);
    }

    return (
      <div style={{ display: "inline", color: "black" }}>
        <Button
          id="runCompareBtn"
          type="button"
          bsStyle="primary"
          onClick={this.runCompareButtonGisEnv}
          disabled={disabledRunCompare}
        >
          Run Compare
        </Button>

        <Modal.Dialog
          bsSize="large"
          dialogClassName="helpModal"
          onHide={this.closeResult}
          show={this.state.showResult}
        >
          <Modal.Header closeButton>
            <Modal.Title>Compare Result</Modal.Title>
          </Modal.Header>

          <div className="modal-body">
            {this.state.data.length} {this.state.message}
            <Button
              bsStyle="primary"
              id="openFieldGuideButton"
              onClick={this.sortResult}
            >
              {" "}
              OK
            </Button>
          </div>
        </Modal.Dialog>

        <Modal.Dialog
          bsSize="large"
          dialogClassName="helpModal"
          onHide={this.closeResult}
          show={this.state.showUpdate}
        >
          <Modal.Header closeButton>
            <Modal.Title>Update GUID</Modal.Title>
          </Modal.Header>

          <div className="modal-body">
            Guid's updated successfully.
            <Button
              bsStyle="primary"
              id="openFieldGuideButtons"
              onClick={this.closeResult}
            >
              {" "}
              OK
            </Button>
          </div>
        </Modal.Dialog>
      </div>
    );
  },
});
